import { _ as _assign, a as __rest } from './tslib.es6-604585c1.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useState, Suspense, lazy, useRef, useMemo } from 'react';
import useGeoZone from './useGeozone/index.js';
import createContext from './createContext/index.js';

var pageVariant;
(function (pageVariant) {
  pageVariant["CONFIRMATION_QUESTION"] = "confirmationQuestion";
  pageVariant["UNDERAGE_MESSAGE"] = "underageMessage";
  pageVariant["TERMS_AND_CONDITIONS"] = "termsAndConditions";
})(pageVariant || (pageVariant = {}));
var Notice;
(function (Notice) {
  Notice["AGE_CONFIRMATION"] = "age_confirmation_notice";
  Notice["ACCOUNT_TERMINATION"] = "account_termination_notice";
})(Notice || (Notice = {}));
var countryCodes;
(function (countryCodes) {
  countryCodes["US"] = "US";
  countryCodes["KR"] = "KR";
})(countryCodes || (countryCodes = {}));

var data = {
  confirmationQuestion: {
    title: 'Are you over 14 years old?',
    description: 'To access and use the Picsart website, you must be 14 years or older.',
    imgSrc: 'https://pastatic.picsart.com/cms-pastatic/15a05b7b-55e0-4f0d-8aa7-1cf6906d8c4a.png',
    note: null,
    buttons: [{
      text: 'Yes',
      filled: true,
      testid: 'age-confirmation-yes',
      isConfirmation: true,
      key: 'age_notice_confirmed'
    }, {
      text: 'No',
      testid: 'age-confirmation-no',
      key: 'age_notice_declined'
    }]
  },
  underageMessage: {
    title: 'Minimum age requirement of 14',
    description: 'To ensure the safety of everyone in the Picsart creative community, we enforce a minimum age requirement of 14. Based on your current age, you’re not old enough to use Picsart. You will be logged out and your account will be deleted shortly. If your Picsart creations aren’t already saved on your device, you may want to consider downloading them as soon as possible.',
    imgSrc: 'https://pastatic.picsart.com/cms-pastatic/adde162a-60d5-45e5-b063-a5c4bb2dde54.png',
    note: null,
    buttons: [{
      text: 'I understand',
      filled: true,
      testid: 'age-confirmation-iunderstand',
      key: 'account_termination_confirmed',
      isConfirmation: true
    }]
  },
  termsAndConditions: {
    title: "We've updated our policies",
    description: 'To continue using Picsart, you must agree to our updated <a href="/terms-of-use" target="_blank">Terms of Use</a> and <a href="/privacy-policy" target="_blank">Privacy policy</a>',
    note: 'Note: You may skip this step a maximum of',
    imgSrc: 'https://pastatic.picsart.com/cms-pastatic/edfa8170-e36b-4eed-9f08-978f6cbec756.png',
    buttons: [{
      text: 'Accept',
      filled: true,
      testid: 'policy-confirmation-yes',
      isConfirmation: true,
      key: 'policy_notice_confirmed'
    }, {
      text: 'Skip for now',
      testid: 'policy-confirmation-no',
      key: 'policy_notice_skiped'
    }]
  }
};
var popupDeniedPages = ['terms-of-use', 'privacy-policy'];

var AgeConfirmationPopup = /*#__PURE__*/lazy(function () {
  return import('./AgeConfirmationPopup/index.js');
});
var AgeConfirmationPopupWrapper = function AgeConfirmationPopupWrapper(_a) {
  var isWhiteLabel = _a.isWhiteLabel;
  var user = useAuthContext().user;
  var _b = useState(),
    country = _b[0],
    setCountry = _b[1];
  useGeoZone(function (geoZone) {
    geoZone && setCountry(geoZone);
  });
  var showPopup = (country === countryCodes.US && !popupDeniedPages.some(function (v) {
    return window.location.href.includes(v);
  }) || country === countryCodes.KR) && !isWhiteLabel;
  return jsx(Fragment, {
    children: (user === null || user === void 0 ? void 0 : user.is_consent_reacted) === false && showPopup && jsx(Suspense, _assign({
      fallback: "null"
    }, {
      children: jsx(AgeConfirmationPopup, {
        country: country
      })
    }))
  });
};

var authStatus;
(function (authStatus) {
  authStatus["pending"] = "pending";
  authStatus["resolved"] = "resolved";
  authStatus["failed"] = "failed";
  authStatus["done"] = "done";
})(authStatus || (authStatus = {}));
var StorageType;
(function (StorageType) {
  StorageType["COUNT"] = "count";
  StorageType["SIZE"] = "size";
})(StorageType || (StorageType = {}));

var defaultState = {
  user: null,
  status: authStatus.pending,
  basePath: '/',
  user_storage_data: null,
  tokenData: null,
  refreshToken: function refreshToken() {
    return Promise.reject(new Error('refreshToken not initialized'));
  }
};

var _a = createContext(defaultState, 'AuthContext'),
  AuthenticationContext = _a.context,
  useAuthContext = _a.useContext;
function AuthProvider(_a) {
  var children = _a.children,
    tokenData = _a.tokenData,
    isWhiteLabel = _a.isWhiteLabel,
    _b = _a.refreshToken,
    refreshToken = _b === void 0 ? function () {
      return Promise.reject(new Error('refreshToken not implemented'));
    } : _b,
    props = __rest(_a, ["children", "tokenData", "isWhiteLabel", "refreshToken"]);
  var tokenDataRef = useRef(tokenData || null);
  var memoizedValues = useMemo(function () {
    return _assign(_assign(_assign({}, defaultState), {
      tokenData: tokenData,
      tokenDataRef: tokenDataRef,
      refreshToken: refreshToken
    }), props);
  }, [tokenData, refreshToken, props]);
  return jsxs(AuthenticationContext.Provider, _assign({
    value: memoizedValues
  }, {
    children: [children, jsx(AgeConfirmationPopupWrapper, {
      isWhiteLabel: isWhiteLabel
    })]
  }));
}

export { AgeConfirmationPopupWrapper as A, Notice as N, StorageType as S, authStatus as a, AuthProvider as b, countryCodes as c, data as d, defaultState as e, AuthenticationContext as f, pageVariant as p, useAuthContext as u };
//# sourceMappingURL=authContext-4a1a5892.js.map
